import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../../hooks/useDeviceQuery.hook';
import { QuestionCircle, QuestionDisplayMode } from '../../CircleText/CircleText';
import { SubText } from '../../Typography';
import { Dash } from './Dash';

export interface BlankDashProps {
  no;
  viewMode: QuestionDisplayMode;
}

const BlankDashContainer = styled.div`
  display: flex;
  .question-no-view-subject {
    &.question-circle {
      margin-right: 8px;
    }
  }

  @media ${deviceBreakpoints.allExceptMobile} {
    .dash {
      width: 124px;
    }
  }
`;

export const BlankDash = (props: BlankDashProps) => {
  const { no, viewMode = QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT } = props;
  return (
    <BlankDashContainer>
      <QuestionCircle className={cl('question-circle', viewMode)}>
        <SubText>{no}</SubText>
      </QuestionCircle>
      <Dash className="dash" />
    </BlankDashContainer>
  );
};
